import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import {NbAuthModule, NbEmailPassAuthProvider} from '@nebular/auth';

import { throwIfAlreadyLoaded } from './module-import-guard';
import { DataModule } from './data/data.module';
import { AnalyticsService } from './utils/analytics.service';
import {MessageService} from './services/message.service';
import { environment} from '../../environments/environment';



const NB_CORE_PROVIDERS = [
  ...DataModule.forRoot().providers,
  ...NbAuthModule.forRoot({
    providers: {
      email: {
        service: NbEmailPassAuthProvider,
        config: {
          delay: 3000,
          baseEndpoint: environment.sailsBackendUrl,
          logout: {
              // alwaysFail: false,
              endpoint: '/user/logout',
              method: 'get',
              redirect: {
                  success: '/',
                  failure: '/',
              },
          },
          login: {
            endpoint: '/user/process',
            rememberMe: true,

          },
            token: {
                key: 'token',
              },
        },
      },
    },
  }).providers,
  AnalyticsService,
  MessageService,
];

@NgModule({
  imports: [
    CommonModule,

  ],
  exports: [
    NbAuthModule,
  ],
  declarations: [
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }

  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders>{
      ngModule: CoreModule,
      providers: [
        ...NB_CORE_PROVIDERS,
      ],
    };
  }
}



// WEBPACK FOOTER //
// /app/src/app/@core/core.module.ts